export class Mobilier {
  MOB_ID: any = null; //number
  RFM_ID: any = null; //number
  PIC_ID: any = null; //number
  MOB_DT_CREA: any = ""; //datetime ?
  MOB_DESCRIPTION: string = "";
  MOB_PRIX: any = null; //number
  MOB_PRIX_UNIT_HT1: any = null; //number
  MOB_PRIX_UNIT_HT2: any = null; //number
  MOB_PRIX_UNIT_HT3: any = null; //number
  MOB_STANDING: any = null; //number
  MOB_QUANTITE: any = null; //number
  MOB_SURFACE: any = null; //number
  CMO_ID: any = null; //number
  SCA_ID: any = null; //number
  MOB_HAUTEUR: any = null; //number
  MOB_LARGEUR: any = null; //number
}
